import { Injectable, SimpleChanges } from '@angular/core';
import { SimpleMQ } from 'ng2-simple-mq';
import { CommonService } from './common.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/Rx';
import * as _ from 'lodash';

import { User, UserByComune } from '../models/user';

@Injectable()
export class UtentiService {
	private user: User = null;
	private permissions: any = null;
	private idMunicipalityAuthorized: any = null;
	private administrator: boolean = false;

	private userByComune: UserByComune = null;
	private _userByComuneSource = new BehaviorSubject<UserByComune>(null);
	public userByComune$ = this._userByComuneSource.asObservable();

	private userLogged: boolean = true;
	private _userLoggedSource = new BehaviorSubject<boolean>(true);
	public userLogged$ = this._userLoggedSource.asObservable();

	constructor(private commonService: CommonService, private smq: SimpleMQ) {
		console.log("SRV|UTENTI - ALIVE!");
		this.smq.subscribe('utenti', e => this.receiveMsg(e));
		this.resetUser();
	}

	setUser(user: User){
		console.log("SRV|UTENTI - setUser user", user, this.user);
		if(user){
			this.user = new User();
			for (let key of Object.keys(user)) {
				let userValue = user[key];
				if(key == 'userData'){
					this.user['detail'] = userValue;
				}else{
					this.user[key] = userValue;
				}
			}
			if(this.user){
				this.getLastAccess(this.user.id, (res) => {
					//console.log("SRV|DS - getLastAccess res", res);
					this.user.ultimoAccesso = res['lastAccessUser'];
				});
				this.userByComune.userComplete = this.user;
				this.userByComune.saluto = this.commonService.getLocale().getSaluto();
			}
			this.userByComune.userComplete = this.user;
			console.log("SRV|UTENTI - setUser", this.user);
		}
		this.setPermissions();
	}

	setPermissions(){
		console.log("SRV|UTENTI - setPermissions");
		this.commonService.getSocket().sendUserId(this.user.id);

		let roles = this.user.roles;
		let services = this.user.services;
		if(roles.length){
			if(roles[0].livello_id == 1){
				this.permissions = 'superadmin';
			}else{
				this.permissions = {};
				for(let role of roles){
					let comune = role.comune_id;
					let livello = role.livello_id;
					if(livello == 2){
						this.permissions[comune] = 'amministratore';
					}else{
						this.permissions[comune] = {};
						this.permissions[comune]['livello'] = livello;
						for(let service of services){
							if(role.id == service.livello_utente_id){
								let servizio = service.nome;
								let dettaglio = JSON.parse(service.dettaglio);
								this.permissions[comune][servizio] = dettaglio;
							}
						}
					}
				}
			}
		}
		this.userByComune.permissions = this.permissions;
		this.commonService.getSocket().permissions = this.permissions;
		this.setIdMunicipalityAuthorized();
	}

	setIdMunicipalityAuthorized(){
		if(this.permissions == 'superadmin'){
			this.idMunicipalityAuthorized = this.permissions;
		}else if(this.permissions){
			this.idMunicipalityAuthorized = Object.keys(this.permissions);
		}
		this.userByComune.idMunicipalityAuthorized = this.idMunicipalityAuthorized;
		console.log("SRV|UTENTI - setIdMunicipalityAuthorized", this.idMunicipalityAuthorized);
		this._userByComuneSource.next(this.userByComune);
	}

	receiveMsg(m) {
		console.log('SRV|UTENTI - receiveMsg:', m);
		if(m){
			let msgSender = m.sender;
			let msgType = m.type;
			let msgKey = m.key;
			let msgValue = m.value;
			switch(msgType){
				case 'richiesta':
					switch(msgKey){
						case 'user':
							this.sendMsg(msgSender, 'risposta', msgKey, this.user);
							break;
						case 'permissions':
							this.sendMsg(msgSender, 'risposta', msgKey, this.permissions);
							break;
						case 'idMunicipalityAuthorized':
							this.sendMsg(msgSender, 'risposta', msgKey, this.idMunicipalityAuthorized);
							break;
						default:
							console.log('SRV|UTENTI - receiveMsg: class', this);
					}
					break;
				case 'risposta':
					switch(msgKey){
						default:
							console.log('SRV|UTENTI - receiveMsg: class', this);
					}
					break;
				default:
			}
		}
	}

	sendMsg(name: string, type: any, key: any, value: any = null) {
		// Publish to queue name
		let m = {
			sender: 'utenti',
			type: type,
			key: key,
			value: value,
		};
		console.log('SRV|UTENTI - sendMsg:', m);
		this.smq.publish(name, m);
	}

	getUserByComune(){
		return this.userByComune;
	}

	getUser(){
		return this.user;
	}

	getUserCf() {
		return this.user.codice_fiscale;
	}

	getUserIdAnagrafica() {
		return this.user.id_anagrafica;
	}

	getUserLevelId(comuneId: any){
		console.log("SRV|UTENTI - getUserLevelId", comuneId);
		let levelId: number = null;
		if (this.permissions) {
			if (this.permissions == 'superadmin') {
				levelId = 1;
			}else if (this.permissions[comuneId]) {
				if (this.permissions[comuneId] == 'amministratore') {
					levelId = 2;
				}else {
					levelId = Number(this.permissions[comuneId].livello);
				}
			}
		}
		console.log("SRV|UTENTI - getUserLevelId", levelId);
		if(levelId)
			return String(levelId);
		else
			levelId;
	}

	getRuoloByComuneId(comuneId: any){
		console.log("getRuoloByComuneId", this.permissions);
		let ruoloUtente = "cittadino";
		if(this.permissions){
			if(this.permissions == "superadmin"){
				ruoloUtente = this.permissions;
			}else if(this.permissions[comuneId] == "amministratore"){
				ruoloUtente = this.permissions[comuneId];
			}else{
				let permissionPerComune = this.permissions[comuneId];
				console.log("getRuoloByComuneId permissionPerComune", permissionPerComune, this.permissions, comuneId);
				if(permissionPerComune){
					if(permissionPerComune['livello'] == 3){
						ruoloUtente = "gestore dei servizi";
					}else if(permissionPerComune['livello'] == 4){
						ruoloUtente = "delegato dei servizi";
					}
				}
			}
		}
		this.userByComune.ruolo = this.commonService.getLocale().capitalizeFirstLetter(ruoloUtente);
		return ruoloUtente;
	}

	getPermissions(){
		return this.permissions;
	}

	readPermissions(comuneId: any){
		let permissionsByComune = null;
		if(this.permissions){
			permissionsByComune = this.permissions;
			if(this.permissions == 'superadmin'){
				this.administrator = true;
			}else if (this.permissions[comuneId] == 'amministratore'){
				this.administrator = true;
			}else{
				permissionsByComune = this.permissions[comuneId];
			}
		}
		return permissionsByComune;
    }

	checkPermission(comuneId: any, key: any, permission: any, filter = 'global') {
		let permissionsByComune = this.readPermissions(comuneId);
		if(permissionsByComune){
			if (this.administrator) {
				return true;
			}else {
				let permissionLocal = permissionsByComune[key];
				if(permissionLocal){
					permissionLocal = permissionLocal[filter];
					if(permissionLocal){
						permissionLocal = permissionLocal[permission];
						if(permissionLocal){
							return permissionLocal;
						}
					}
				}
				return false;
			}
		}else{
			if((key == 'profilo-utente' || key == 'dashboard' || key == 'situazione-contribuente' || key == 'conversazioni') && permission == 'read'){
				//console.log("checkPermission cittadino", key, permission);
				return true;
			}
			return false;
		}
	}

	getSystemNotifications(comuniIds) {
		console.log("SRV| UTENTI - getSystemNotifications", comuniIds, this.user, this.permissions);
		if(this.user){
			// get notifiche sistema utente
			if (this.permissions) {
				let body: any = {
					user_ids: comuniIds
				};
				console.log("SRV| UTENTI - getSystemNotifications", body, comuniIds);
				return this.commonService.getDB().getNotificheSistema(body);
			} else {
				let body: any = {
					user_ids: this.user.id
				};
				console.log("SRV| UTENTI - getSystemNotifications", body, this.user.id);
				return this.commonService.getDB().getNotificheSistema(body);
			}
		}
	}

	getLastAccess(userID, callback = null){
		//console.log("SRV|UTENTI - getLastAccessByUserID", userID);
		let localFilters: any = [];
		let localSets: any = {};
		localFilters.push({ type: "=", key: "utente_id", value: userID });
		localFilters.push({ type: "=", key: "`log_attivita`.attivita", value: "'login'" });
		this.commonService.getDB().runQuery("last_access_user", localFilters, localSets)
		.subscribe(
			(data) => {
				if(callback){
					callback(this.commonService.readDatabaseResponse('', data));
				}
			},
			(error) => {
				console.log("SRV|DS - lastAccessUser error", error);
			},
			() => {
			}
		);
	}

	fillPermissions(user: User){
		console.log("SRV|UTENTI - fillPermissions", user);
		let roles = user.roles;
		let services = user.services;
		let permissions: any = null;

		if(roles.length){
			if(roles[0].livello_id == 1){
				permissions = 'superadmin';
			}else{
				permissions = {};
				for(let role of roles){
					let comune = role.comune_id;
					let livello = role.livello_id;
					if(livello == 2){
						permissions[comune] = 'amministratore';
					}else{
						permissions[comune] = {};
						permissions[comune]['livello'] = livello;
						for(let service of services){
							if(role.id == service.livello_utente_id){
								let servizio = service.nome;
								let dettaglio = JSON.parse(service.dettaglio);
								permissions[comune][servizio] = dettaglio;
							}
						}
					}
				}
			}
		}
		console.log("SRV|UTENTI - fillPermissions", permissions);
		return permissions;
	}

	fillIdMunicipalityAuthorized(permissions: any){
		let idMunicipalityAuthorized: any = null;
		if(permissions == 'superadmin'){
			idMunicipalityAuthorized = permissions;
		}else if(permissions){
			idMunicipalityAuthorized = Object.keys(permissions);
		}
		//console.log("SRV|UTENTI - fillIdMunicipalityAuthorized", idMunicipalityAuthorized);
		return idMunicipalityAuthorized;
	}

	fillUserLevelId(permissions: any, comuneId: number){
		console.log("SRV|UTENTI - fillUserLevelId", permissions, comuneId);
		let levelId: number = null;
		if (permissions) {
			if (permissions == 'superadmin') {
				levelId = 1;
			}else if (permissions[comuneId]) {
				if (permissions[comuneId] == 'amministratore') {
					levelId = 2;
				}else {
					levelId = Number(permissions[comuneId].livello);
				}
			}
		}
		//console.log("SRV|UTENTI - fillUserLevelId", levelId);
		if(levelId)
			return String(levelId);
		else
			levelId;
	}

	fillRuoloByComuneId(permissions: any, comuneId: number){
		let ruoloUtente = "cittadino";
		if(permissions){
			if(permissions == "superadmin"){
				ruoloUtente = permissions;
			}else if(permissions[comuneId] == "amministratore"){
				ruoloUtente = permissions[comuneId];
			}else if(permissions[comuneId]['livello'] == 3){
				ruoloUtente = "gestore dei servizi";
			}else if(permissions[comuneId]['livello'] == 4){
				ruoloUtente = "delegato dei servizi";
			}
		}
		return ruoloUtente;
	}

	fillUserComplete(user: User, comuneId: number, callback = null){
		this.commonService.getDB().getUserRolesByComuneId(user.id, comuneId).subscribe(
			data => { user.roles = data['ruoli']; },
			error => { console.log("SRV|DS - getUserRolesByComuneId error", error); },
			() => {
				console.log("SRV|DS - fillUserComplete roles", user.roles);
				this.commonService.getDB().getUserServicesByComuneId(user.id, comuneId).subscribe(
					data => { user.services = data['permessi']; },
					error => { console.log("SRV|DS - getUserServicesByComuneId error", error); },
					() => {
						console.log("SRV|DS - fillUserComplete services", user.services);
						this.getLastAccess(user.id, (res) => {
							//console.log("SRV|DS - getLastAccess res", res);
							//user.ultimoAccesso = res.data['lastAccessUser'];
							user.ultimoAccesso = res['lastAccessUser'];
							//console.log("SRV|DS - getLastAccess lastAccessUser", user.ultimoAccesso);
							if(callback){
								callback(user);
							}
						});
					}
				);
			}
		);
	}

	getUserByComuneComplete(localUser: User, comuneId: number, callback = null){
		console.log("SRV|UTENTI - getUserByComuneComplete user", localUser);
		if(localUser){
			this.fillUserComplete(localUser, comuneId, (user) => {
				console.log("SRV|DS - fillUserComplete user", user);
				let userByComune: UserByComune = new UserByComune(user);
				userByComune.saluto = this.commonService.getLocale().getSaluto();
				userByComune.permissions = this.fillPermissions(user);
				userByComune.idMunicipalityAuthorized = this.fillIdMunicipalityAuthorized(userByComune.permissions);
				userByComune.userLevelId = this.fillUserLevelId(userByComune.permissions, comuneId);
				userByComune.ruolo = this.fillRuoloByComuneId(userByComune.permissions, comuneId);
				console.log("SRV|UTENTI - getUserByComuneComplete user", user);
				userByComune.userComplete = user;
				console.log("SRV|UTENTI - getUserByComuneComplete userByComune", userByComune);
				if(callback){
					callback(userByComune);
				}
			});
		}
	}

	resetUser(){
		this.userByComune = new UserByComune();
		this.user = null;
		this.permissions = null;
		this.idMunicipalityAuthorized = null;
		this.administrator = false;
	}
}
